// Captures the autologin token out of the URL and removes it, at MODULE LOAD.
//
// This file is imported first from index.js, before React renders and before
// initializeAnalytics() runs, and that ordering is the point. Stripping the
// token inside an effect leaves a window in which GTM and Clevertap have
// already seen the address — a single-use credential ends up in analytics
// payloads, in the referrer of the next outbound request, and in browser
// history where the next person on a shared machine can press Back.

export const AUTOLOGIN_PARAM = 'at';

let capturedToken = null;

(function captureAndStrip() {
  if (typeof window === 'undefined') return;

  try {
    const url = new URL(window.location.href);
    const token = url.searchParams.get(AUTOLOGIN_PARAM);
    if (!token) return;

    capturedToken = token;

    url.searchParams.delete(AUTOLOGIN_PARAM);
    // replaceState, not pushState: the token URL must not become a history
    // entry somebody can navigate back to.
    window.history.replaceState(null, '', `${url.pathname}${url.search}${url.hash}`);
  } catch {
    // A URL we cannot parse simply carries no token.
  }
}());

/**
 * Returns the token once. Every later call returns null.
 *
 * React StrictMode double-invokes effects in development, and the token is
 * single-use at the tokens service — the second call would spend a token the
 * first call already consumed and the student would land on the OTP screen
 * anyway. One caller, one token.
 */
export function consumeAutologinToken() {
  const token = capturedToken;
  capturedToken = null;
  return token;
}

export function hasPendingAutologin() {
  return Boolean(capturedToken);
}
